import { registerBlockType } from '@wordpress/blocks'
import ServerSideRender from '@wordpress/server-side-render'

registerBlockType('usna1978/upcoming-events', {
  title: 'Upcoming Events',
  description: 'A list of events that are coming up.',
  icon: 'calendar',
  category: 'widgets',

  /**
   * The edit function describes the structure of your block in the context of
   * the editor. This represents what the editor will render when the block is
   * used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  edit () {
    return (
      <ServerSideRender
        block='usna1978/upcoming-events'
      />
    )
  },

  /**
   * The save function defines the way in which the different attributes should
   * be combined into the final markup, which is then serialized by Gutenberg
   * into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  save () {
    return null
  }
})
